import React from 'react';
import {Field} from 'redux-form';
import {connect} from 'react-redux';

class Submit extends React.Component {
    constructor( props ) {
        super( props );
    }

    render() {
        if ( !this.props.visible ) return null;
        const { office, product } = this.props;
        const style = this.props.errorStyle;
        if ( (product.onlinefulfillment && office.code !='uk')|| !office.config.agreeToTermsMessageTop ) {
            return null;
        }
        else {
            return (
                <fieldset>
                    <legend>Inspection Copy Agreement</legend>
                    <div className="gratisRequestInstructions">
                        <div className="paragraph"
                             dangerouslySetInnerHTML={{ __html: office.config.agreeToTermsMessageTop }}>
                        </div>
                        <div id="agreeToTermsContainer">
                            <Field style={style( 'termsAndConditions' ).input} type="checkbox" component="input"
                                   name="termsAndConditions"/>
                            <b style={style( 'termsAndConditions' ).label}>I understand and agree to the terms of the
                                agreement above.</b>
                        </div>
                    </div>
                </fieldset>
            )
        }
    }
}

export default connect( state => state )( Submit );


// WEBPACK FOOTER //
// ./src/form/components/AgreeToTerms.jsx